import { render, staticRenderFns } from "./IcoVerseMaterial.vue?vue&type=template&id=00e4c369"
import script from "./IcoVerseMaterial.vue?vue&type=script&lang=js"
export * from "./IcoVerseMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports